const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://ppsyftxto6.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://0irwqv4oph.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://k3zxqskfy4.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.newmont.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.newmont.forwoodsafety.com',
    WEBSOCKET: 'wss://60brha8aij.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;